import __vue_normalize__ from '../../../node_modules/vue-runtime-helpers/dist/normalize-component.js';
import { a as _toConsumableArray, b as _defineProperty } from './_rollupPluginBabelHelpers-6458ff47.js';
import _mergeJSXProps from '../../../node_modules/babel-helper-vue-jsx-merge-props/index.js';

/**
 * @file 公用的一些函数
 *
 * @author 天翔Skyline(skyline0705@gmail.com)
 * 23 Mar 2018
 */
function isScrollElement(el) {
  return el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
}

function getScrollParentList(el) {
  var list = [];
  var parent = el.parentNode;

  while (parent && parent !== document.documentElement) {
    if (isScrollElement(parent)) {
      list.push(parent);
    }

    parent = parent.parentNode;
  }

  return list.concat(window);
}
var PLACEMENT_LIST = ['top', 'left', 'right', 'bottom', 'top-left', 'top-right', 'bottom-left', 'bottom-right'];
var space = 10;

function getOffset(el) {
  return el.getBoundingClientRect();
}

function getToolTipSize(tooltip) {
  var copyTooltip = tooltip.cloneNode(true);
  document.body.appendChild(copyTooltip);
  copyTooltip.style.top = '-99999px';
  copyTooltip.style.position = 'fixed';
  copyTooltip.style.display = 'block';
  copyTooltip.style.width = '';
  var width = copyTooltip.offsetWidth;
  var height = copyTooltip.offsetHeight;
  document.body.removeChild(copyTooltip);
  return {
    width: width,
    height: height
  };
}

function calculatePlacement(_ref) {
  var top = _ref.top,
      right = _ref.right,
      bottom = _ref.bottom,
      left = _ref.left;
  // TODO这块策略没想好，导致现在会有些乱，后面再考虑
  var placement = [];

  if (bottom.avaliable && bottom.space >= top.space) {
    placement.push('bottom');
  }

  if (top.avaliable && top.space > bottom.space) {
    placement.push('top');
  }

  if (left.avaliable && right.avaliable && placement.length) {
    return placement.join('-');
  }

  if (left.avaliable && placement.length && !right.avaliable) {
    placement.push('left');
    return placement.join('-');
  }

  if (right.avaliable && placement.length && !left.avaliable) {
    placement.push('right');
    return placement.join('-');
  }

  if (placement.length) {
    return placement.join('-');
  }

  if (right.avaliable && right.space >= left.space) {
    return 'right';
  }

  if (left.avaliable && left.space > right.space) {
    return 'left';
  }

  return 'bottom';
}

function getCurrentPlacement(_ref2) {
  var tooltipSize = _ref2.tooltipSize,
      triggerRectInfo = _ref2.triggerRectInfo;
  var _window = window,
      windowWidth = _window.innerWidth,
      windowHeight = _window.innerHeight;
  var spaceInfo = {
    top: {
      avaliable: triggerRectInfo.top >= tooltipSize.height + space,
      space: triggerRectInfo.top
    },
    bottom: {
      avaliable: windowHeight - triggerRectInfo.bottom >= tooltipSize.height + space,
      space: windowHeight - triggerRectInfo.bottom
    },
    left: {
      avaliable: triggerRectInfo.left >= tooltipSize.width / 2,
      space: triggerRectInfo.left
    },
    right: {
      avaliable: windowWidth - triggerRectInfo.right >= tooltipSize.width / 2,
      space: windowWidth - triggerRectInfo.right
    }
  };
  return calculatePlacement(spaceInfo);
} // TODO先放到这里吧


function calculatePosition() {
  var tooltip = this.$refs.tooltip;
  var trigger = this.$slots.default[0].elm;

  if (!tooltip || !trigger || !this.tooltipInDom) {
    return;
  }

  var _getToolTipSize = getToolTipSize(tooltip),
      width = _getToolTipSize.width,
      height = _getToolTipSize.height;

  tooltip.style.width = Math.ceil(width) + 'px';
  var triggerRectInfo = getOffset(trigger);
  this.realPlacement = PLACEMENT_LIST.includes(this.placement) ? this.placement : getCurrentPlacement({
    tooltipSize: {
      width: width,
      height: height
    },
    triggerRectInfo: triggerRectInfo
  });

  switch (this.realPlacement) {
    case 'top':
      this.positionInfo.left = triggerRectInfo.left - width / 2 + triggerRectInfo.width / 2;
      this.positionInfo.top = triggerRectInfo.top - height - space;
      this.arrowLeft = null;
      break;

    case 'left':
      if (!this.isAbsoluteMode) {
        this.positionInfo.left = triggerRectInfo.left - width - space;
        this.positionInfo.top = triggerRectInfo.top + trigger.offsetHeight / 2 - height / 2;
      } else {
        this.positionInfo.left = -(width + space);
        this.positionInfo.top = trigger.offsetHeight / 2 - height / 2;
      }

      this.arrowLeft = null;
      break;

    case 'right':
      this.positionInfo.left = triggerRectInfo.left + trigger.offsetWidth + space;
      this.positionInfo.top = triggerRectInfo.top + trigger.offsetHeight / 2 - height / 2;
      this.arrowLeft = null;
      break;

    case 'bottom':
      this.positionInfo.left = triggerRectInfo.left - width / 2 + triggerRectInfo.width / 2;
      this.positionInfo.top = triggerRectInfo.top + trigger.offsetHeight + space;
      this.arrowLeft = null;
      break;

    case 'top-left':
      this.positionInfo.left = triggerRectInfo.left - width + triggerRectInfo.width;
      this.positionInfo.top = triggerRectInfo.top - height - space;
      this.arrowLeft = width - triggerRectInfo.width / 2;
      break;

    case 'top-right':
      this.positionInfo.left = triggerRectInfo.left;
      this.positionInfo.top = triggerRectInfo.top - height - space;
      this.arrowLeft = triggerRectInfo.width / 2;
      break;

    case 'bottom-left':
      if (!this.isAbsoluteMode) {
        this.positionInfo.left = triggerRectInfo.left - width + triggerRectInfo.width;
        this.positionInfo.top = triggerRectInfo.top + trigger.offsetHeight + space;
      } else {
        this.positionInfo.left = triggerRectInfo.width - width;
        this.positionInfo.top = trigger.offsetHeight + space;
      }

      this.arrowLeft = width - triggerRectInfo.width / 2;
      break;

    case 'bottom-right':
      this.positionInfo.left = triggerRectInfo.left;
      this.positionInfo.top = triggerRectInfo.top + trigger.offsetHeight + space;
      this.arrowLeft = triggerRectInfo.width / 2;
      break;
  }
}
function combineHandlers(originalHandlers, handlers) {
  if (!originalHandlers) {
    originalHandlers = [];
  } else if (typeof originalHandlers === 'function') {
    originalHandlers = [originalHandlers];
  }

  if (typeof handlers === 'function') {
    return [].concat(_toConsumableArray(originalHandlers), [handlers]);
  }

  if (Array.isArray(handlers)) {
    return [].concat(_toConsumableArray(originalHandlers), _toConsumableArray(handlers));
  }

  return originalHandlers;
} // TODO这货应该抽到全局util中

function closest(el, parent) {
  while (el) {
    if (el === parent) {
      return parent;
    }

    el = el.parentNode;
  }

  return null;
}

var script = {
  name: 'pl-tooltip',
  props: {
    // 提示内容
    content: {
      type: String
    },
    // 位置
    placement: {
      type: String,
      default: 'auto'
    },
    // 最大宽度
    maxWidth: {
      type: Number,
      default: 200
    },
    // 显示延迟值
    delay: {
      type: Object,
      default: function _default() {
        return {
          show: 0,
          hide: 200
        };
      }
    },
    // 显示触发方式 可选 hover | click
    trigger: {
      default: 'hover',
      validator: function validator(trigger) {
        return ['click', 'hover'].includes(trigger);
      }
    },
    // 是否插入到body
    insertToGlobal: {
      type: Boolean,
      default: true
    },
    // 自定义样式
    customClass: {
      type: String,
      default: ''
    },
    // 是否手动触发
    manual: Boolean,
    isAbsoluteMode: Boolean
  },
  data: function data() {
    return {
      positionInfo: {
        top: 0,
        left: 0
      },
      arrowLeft: null,
      isShow: false,
      realPlacement: '',
      tooltipInDom: false,
      staticClass: '',
      attrClass: '',
      scopeId: ''
    };
  },
  methods: {
    calculatePosition: calculatePosition,
    triggerEvent: function triggerEvent(eventName) {
      // before-show, after-show, before-hide, after-hide
      this.$emit(eventName);
    },
    // 显示
    show: function show() {
      var _this = this;

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
        return;
      }

      this.createTooltip();
      this.calculatePosition();

      if (this.delay.show <= 0) {
        this.isShow = true;
      } else {
        this.timeoutId = setTimeout(function () {
          _this.isShow = true;
          _this.timeoutId = null;
        }, this.delay.show);
      }
    },
    // 隐藏
    hide: function hide() {
      var _this2 = this;

      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }

      if (this.delay.hide <= 0) {
        this.isShow = false;
      } else {
        this.timeoutId = setTimeout(function () {
          _this2.isShow = false;
          _this2.timeoutId = null;
        }, this.delay.hide);
      }
    },
    destroyTooltip: function destroyTooltip() {
      this.triggerEvent('after-hide');

      if (!this.tooltipInDom) {
        return;
      }

      this.$refs.tooltip.parentNode.removeChild(this.$refs.tooltip);
      this.tooltipInDom = false;
    },
    createTooltip: function createTooltip() {
      this.lastInsertToGlobal = this.insertToGlobal;

      if (this.lastInsertToGlobal) {
        document.body.appendChild(this.$refs.tooltip);
      } else {
        this.$el.insertAdjacentElement('afterend', this.$refs.tooltip);
      }

      this.tooltipInDom = true;
    }
  },
  beforeCreate: function beforeCreate() {
    this.tooltip = new this.$root.constructor({
      data: function data() {
        return {
          node: ''
        };
      },
      parent: this.$parent,
      render: function render() {
        return this.node;
      }
    });
  },
  beforeUpdate: function beforeUpdate() {
    // hack逻辑
    this.staticClass = this.$vnode.data.staticClass;
    this.attrClass = this.$vnode.data.class;
  },
  updated: function updated() {
    // hack逻辑
    this.$el.classList.remove(this.$vnode.data.staticClass);
    this.$el.classList.remove(this.$vnode.data.class);
  },
  mounted: function mounted() {
    var _this3 = this;

    this.calculatePosition();
    this.staticClass = this.$vnode.data.staticClass;
    this.attrClass = this.$vnode.data.class;
    /* eslint-disable no-underscore-dangle */

    this.scopeId = this.$vnode.context.$options._scopeId;
    this.$el.classList.remove(this.$vnode.data.staticClass);
    this.$el.classList.remove(this.$vnode.data.class);
    this.tooltip.$mount();
    this.scrollElList = getScrollParentList(this.$el);
    this.scrollElList.forEach(function (el) {
      el.addEventListener('scroll', _this3.calculatePosition, false);
    }); // TODO有点脏了，后面再说

    if (this.trigger === 'click') {
      this.globalHide = function (event) {
        if (closest(event.target, _this3.$refs.tooltip) || closest(event.target, _this3.$slots.default[0].elm) || _this3.manual) {
          return;
        }

        _this3.hide();
      };

      window.addEventListener('click', this.globalHide, true);
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _this4 = this;

    this.scrollElList.forEach(function (el) {
      el.removeEventListener('scroll', _this4.calculatePosition);
    });
    this.scrollEl = null;
    this.destroyTooltip();
    this.tooltip.$destroy();
    this.tooltip = null;
    this.timeoutId = null;

    if (this.trigger === 'click') {
      window.removeEventListener('click', this.globalHide, true);
    }
  },
  render: function render() {
    var h = arguments[0];
    var extAttrs = this.scopeId ? {
      attrs: _defineProperty({}, this.scopeId, true)
    } : {};
    var contentSlot = h("div", {
      "class": "pl-tooltip-content",
      style: {
        'max-width': this.maxWidth + 'px'
      }
    }, [this.$slots.content ? this.$slots.content : this.content]);

    if (this.trigger === 'hover' && !this.manual) {
      contentSlot.data.on = contentSlot.data.on || {};
      contentSlot.data.on.mouseenter = this.show;
      contentSlot.data.on.mouseleave = this.hide;
    } // TODO后面再考虑那个bind怎么搞合适

    /* eslint-disable no-extra-parens */


    this.tooltip.node = h("transition", {
      attrs: {
        name: "scale"
      },
      on: {
        "before-enter": this.triggerEvent.bind(this, 'before-show'),
        "after-enter": this.triggerEvent.bind(this, 'after-show'),
        "before-leave": this.triggerEvent.bind(this, 'before-hide'),
        "after-leave": this.destroyTooltip
      }
    }, [h("div", _mergeJSXProps([{
      "class": ['pl-tooltip', this.realPlacement, this.staticClass, this.attrClass],
      ref: "tooltip",
      directives: [{
        name: "show",
        value: this.isShow
      }],
      style: {
        top: this.positionInfo.top + 'px',
        left: this.positionInfo.left + 'px'
      }
    }, extAttrs]), [this.arrowLeft === null ? h("div", {
      "class": "pl-tooltip-arrow"
    }) : h("div", {
      "class": "pl-tooltip-arrow",
      style: {
        left: this.arrowLeft + 'px'
      }
    }), contentSlot])]);
    var vnode = this.$slots.default[0];

    if (!vnode.tag) {
      throw new Error(['[platform-ui pl-tooltip error]: ', 'trigger element should not be a text node.'].join(''));
    }

    vnode.data = vnode.data || {};
    vnode.data.on = vnode.data.on || {};

    if (this.manual) {
      return vnode;
    }

    if (this.trigger === 'hover') {
      vnode.data.on.mouseenter = combineHandlers(vnode.data.on.mouseenter, this.show);
      vnode.data.on.mouseleave = combineHandlers(vnode.data.on.mouseleave, this.hide);
    } else if (this.trigger === 'click' && !this.tooltipInDom) {
      vnode.data.on.click = combineHandlers(vnode.data.on.click, this.show);
    } else if (this.trigger === 'click' && this.tooltipInDom) {
      vnode.data.on.click = combineHandlers(vnode.data.on.click, this.hide);
    }

    return vnode;
  }
};

/* script */
const __vue_script__ = script;
/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  

  
  var plTooltip = __vue_normalize__(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

export default plTooltip;
